export const FILTER_PERIOD = 'relativePeriod';
export const FILTER_ADDED = 'relativeAddedPeriod';
export const FILTER_ACTION_TYPE = 'actionType';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_CREATED_BY = 'creators';
export const FILTER_STATUSES = 'statuses';
export const FILTER_TYPES = 'types';

export const FILTERS = 'filters';
export const TABLE_SETTINGS = 'tableSettings';
export const LIMIT = 'limit';
export const OFFSET = 'offset';
export const ORDER_BY = 'orderBy';
export const ORDER_DIR = 'orderDir';
export const SEARCH_QUERY = 'q';

export const TYPE_FR = 0;
export const TYPE_IO = 1;
export const TYPE_SA = 2;

const PERIOD_LIFETIME_PLUS_FUTURE = 0;
const ADDED_THIS_MONTH = 0;
const ACTION_TYPES_ALL = 0;
const ACTION_TYPES_REQUIRE_MY_ATTENTION = 1;

export const AVATAR_BY_ACTION_TYPE_MAP = new Map([
  [ACTION_TYPES_ALL, 'bordered'],
  [ACTION_TYPES_REQUIRE_MY_ATTENTION, 'filled'],
]);

export const initialState = {
  [FILTERS]: {
    [FILTER_PERIOD]: PERIOD_LIFETIME_PLUS_FUTURE,
    [FILTER_ADDED]: ADDED_THIS_MONTH,
    [FILTER_ACTION_TYPE]: ACTION_TYPES_REQUIRE_MY_ATTENTION,
  },
  [TABLE_SETTINGS]: {
    [SEARCH_QUERY]: undefined,
    [LIMIT]: 15,
    [OFFSET]: 0,
    [ORDER_BY]: 'createdDate',
    [ORDER_DIR]: 'desc',
  },
};

export const SORT_LIST = [
  {
    text: 'Newest',
    role: 'sort',
    data: {
      orderBy: 'createdDate',
      orderDir: 'desc',
    },
  },
  {
    text: 'Oldest',
    role: 'sort',
    data: {
      orderBy: 'createdDate',
      orderDir: 'asc',
    },
  },
  {
    text: 'High budget',
    role: 'sort',
    data: {
      orderBy: 'budget',
      orderDir: 'desc',
    },
  },
  {
    text: 'Low budget',
    role: 'sort',
    data: {
      orderBy: 'budget',
      orderDir: 'asc',
    },
  },
  {
    text: 'Due date',
    role: 'sort',
    data: {
      orderBy: 'dueDate',
      orderDir: 'desc',
    },
  },
];
